// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

common.View.create('canvas.blocks.custom.latestProjects.Block', {
    onDOMLoad() {
        this.initSwiper();
    },

    initSwiper() {
        new Swiper('.mySwiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 32,
                },
                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 32,
                },
                1024: {
                    slidesPerView: 2.25,
                    spaceBetween: 32,
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
    },
});
